(function () {
  var FREE_SHIPPING_VARIANT_ID = 67726631862576;
  var cleanupPromise = null;

  function cartUrl(path) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
  }

  function removeLegacyFreeShipping() {
    if (cleanupPromise) return cleanupPromise;
    cleanupPromise = fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read cart.');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (Number(item.variant_id || item.id) === FREE_SHIPPING_VARIANT_ID) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return cart;
        return fetch(cartUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not remove Free Shipping product.');
          return response.json();
        });
      })
      .catch(function (error) {
        console.error('Free Shipping cleanup failed:', error);
      })
      .finally(function () {
        cleanupPromise = null;
      });
    return cleanupPromise;
  }

  window.AP_RECONCILE_FREE_SHIPPING = removeLegacyFreeShipping;
  window.addEventListener('pageshow', removeLegacyFreeShipping);
})();

